import { render, staticRenderFns } from "./CustomerVisitsOverview.vue?vue&type=template&id=a0864af4&scoped=true&"
import script from "./CustomerVisitsOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerVisitsOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVisitsOverview.vue?vue&type=style&index=0&id=a0864af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0864af4",
  null
  
)

export default component.exports